/// <amd-module name="Artifacts/Pypi/redux/Actions" />
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  IDeleteActionPayload,
  IPromoteActionPayload,
  IRestoreActionPayload,
  IUpstreamOverrideActionPayload,
} from "Artifacts/Root/Protocols/types/ICommandActionPayloads";
import { trackActionWithCount } from "Artifacts/Root/redux/Actions";
import { IFeed, IPackageVersionIdentity } from "Artifacts/Root/types";
import { ActionsUnion, createAction, trackedAction } from "redux/Utils/ActionHelper";

export const enum PypiActionTypes {
  Promote = "Artifacts/Pypi/Promote",
  PermanentDelete = "Artifacts/Pypi/PermanentDelete",
  Restore = "Artifacts/Pypi/Restore",
  SoftDelete = "Artifacts/Pypi/SoftDelete",
  SetUpstreamOverride = "Artifacts/Pypi/SetUpstreamOverride",
}

export const PypiActions = {
  promote: (
    feed: IFeed,
    versions: IPackageVersionIdentity[],
    viewId: string,
    onSuccessCallback: () => void,
  ) =>
    trackActionWithCount(
      createAction<PypiActionTypes, IPromoteActionPayload>(PypiActionTypes.Promote, {
        feed,
        versions,
        viewId,
        onSuccessCallback,
      }),
      versions.length,
    ),
  permanentDelete: (
    feed: IFeed,
    versions: IPackageVersionIdentity[],
    onSuccessCallback: () => void,
  ) =>
    trackActionWithCount(
      createAction<PypiActionTypes, IDeleteActionPayload>(PypiActionTypes.PermanentDelete, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
  restore: (feed: IFeed, versions: IPackageVersionIdentity[], onSuccessCallback: () => void) =>
    trackActionWithCount(
      createAction<PypiActionTypes, IRestoreActionPayload>(PypiActionTypes.Restore, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
  softDelete: (feed: IFeed, versions: IPackageVersionIdentity[], onSuccessCallback: () => void) =>
    trackActionWithCount(
      createAction<PypiActionTypes, IDeleteActionPayload>(PypiActionTypes.SoftDelete, {
        feed,
        versions,
        onSuccessCallback,
      }),
      versions.length,
    ),
  setUpstreamOverride: (
    feed: IFeed,
    packageName: string,
    allowExternalVersions: boolean,
    onSuccessCallback: () => void,
  ) =>
    trackedAction(
      createAction<PypiActionTypes, IUpstreamOverrideActionPayload>(
        PypiActionTypes.SetUpstreamOverride,
        { feed, packageName, allowExternalVersions, onSuccessCallback },
      ),
    ),
};

export type PypiActionsUnion = ActionsUnion<typeof PypiActions>;
